module.exports = __webpack_public_path__ + "img/flow.95770aba.png";